export default {
  CREATE: `Créer une pause`,
  CREATE_RULE: `Créer une règle de pauses`,
  DELETE_BUTTON: {
    TITLE: `Supprimer la pause`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cette pause ?`,
    PRIMARY_ACTION: `Supprimer la pause`
  },
  DELETE_BUTTON_RULE: {
    TITLE: `Supprimer la règle de pause`,
    SUMMARY: ``,
    PRIMARY_ACTION: `Supprimer la règle de pause`
  },
  LIST: {
    TITLE: `Liste des pauses`
  },
  LIST_RULES: {
    TITLE: `Liste des règles de pauses`
  },
  DURATION: `Durée`,
  PAID: `Payée`,
  PREVENTPUNCHING: `Empêcher le poinçonnage`,
  BREAKS: `Pauses`,
  THRESHOLD: `Seuil`,
  form: {
    CREATE: {
      TITLE: `Création d'une pause`,
      SUMMARY: ``
    },
    CREATE_RULE: {
      TITLE: `Création d'une règle de pause`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Modification d'une pause`,
      SUMMARY: ``
    },
    EDIT_RULE: {
      TITLE: `Modification d'une règle de pause`,
      SUMMARY: ``
    },
    NAME: {
      LABEL: `Nom de la pause`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement la repérer.`,
      PLACEHOLDER: `Entrez un nom pour la pause`
    },
    PAID: {
      LABEL: `Payée`,
      DESCRIPTION: `Les pauses payées seront comptées dans les heures travaillées, contrairement aux pauses non-payées.`
    },
    PREVENTPUNCHING: {
      LABEL: `Empêcher le poinçonnage`,
      DESCRIPTION: `Cette pause ne pourra pas être poinçonnée par les employés.`
    },
    DURATION: {
      LABEL: `Durée de la pause`,
      DESCRIPTION: `La durée doit être entrée en minutes.`,
      PLACEHOLDER: `Entrez la durée de la pause`
    },
    THRESHOLD: {
      LABEL: `Durée du quart`,
      DESCRIPTION: `Cette pause sera ajoutée au quart après une certaine durée en minutes.`,
      PLACEHOLDER: `Entrez une durée`
    },
    SCHEDULEDTIME: {
      LABEL: `Heure de la pause`,
      DESCRIPTION: `Cette pause sera ajoutée au quart à une heure spécifique, l'heure de fin sera calculée à partir de cette heure.`,
      PLACEHOLDER: `Entrez une heure`
    },
    DEPARTMENTS: {
      LABEL: `Département`,
      DESCRIPTION: `Département de la position`
    },
    NAME_REQUIRED: `Le nom de la pause est obligatoire.`,
    INVALID_BREAK_DURATION: `La durée de la pause doit être un nombre rond compris entre 1 et 300.`,
    DURATION_REQUIRED: `La durée de la pause est obligatoire.`,
    AUTOASSIGN: {
      LABEL: `Assignement automatique`,
      OPTIONS: {
        NONE: { LABEL: `Ne pas assigner automatiquement`, DESCRIPTION: `` },
        THRESHOLD: { LABEL: `Durée minimale`, DESCRIPTION: `` },
        SCHEDULED_TIME: { LABEL: `Heure pré-déterminée`, DESCRIPTION: `` }
      }
    }
  },
  rulesForm: {
    NAME: {
      LABEL: `Nom de la règle de pause`,
      DESCRIPTION: `Ce nom devrait vous permettre de facilement la repérer.`,
      PLACEHOLDER: `Entrez un nom pour la pause`
    },
    THRESHOLD: {
      LABEL: `Temps de travail minimal`,
      DESCRIPTION: `Le quart de travail doit avoir une certaine durée pour que la régle s'applique`,
      PLACEHOLDER: `Entrez le temps de travail minimal voulu`
    },
    BREAKS_PLACEHOLDER: `Entrez la quantité de pauses à ajouter`,
    AMOUNT_OF_BREAK: `Nombre de pauses voulu`,
    BREAKS_TO_ADD: `Type de pauses à ajouter et leurs quantité`,
    NAME_REQUIRED: `Le nom de la règle de pause est obligatoire.`,
    INVALID_BREAK_THRESHOLD: `Le temps de travail minimal doit être un nombre rond compris entre 1 et 1440.`,
    THRESHOLD_REQUIRED: `Le temps de travail minimal est obligatoire.`,
    INVALID_BREAK_AMOUNT: `Le nombre de pauses est invalide`,
    BREAK_AMOUNT_REQUIRED: `Le nombre de pauses est obligatoire, il doit y en avoir au moins une.`
  }
}
